import ModelService from "./abstract/ModelService";
import ContractCustomerSignOff from "../models/ContractCustomerSignOff";

export default class ContractCustomerSignOffService extends ModelService {
  constructor(hash) {
    super(`/contract/${hash}/sign-off`, ContractCustomerSignOff);
  }

  uploadImage(model) {
    return new Promise((resolve, reject) => {
      this.post(env.API_URL + this.modelPath + "/image", model, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(data => {
          resolve(data);
        })
        .catch(e => reject(e.response));
    });
  }
}
